var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('base-label',{attrs:{"text":_vm.groupName,"small":_vm.small,"large":_vm.large,"no-decoration":""}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }